import { View } from "react-native";

import { useTheme } from "../../utils/theme";

import type { ReactNode } from "react";
import type { StyleProp, ViewStyle } from "react-native";
import type { TestProps } from "../../types";

export interface DialogContentProps extends TestProps {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}

export function DialogContent({ children, style, testID }: DialogContentProps) {
  const { colors, shadows, rounding } = useTheme();
  return (
    <View
      testID={testID}
      style={[
        {
          backgroundColor: colors.dialogBackground,
          borderRadius: rounding.lg,
        },
        shadows.regular,
        style,
      ]}
    >
      {children}
    </View>
  );
}
